module.exports = __webpack_public_path__ + "static/img/020.af573268.jpg";